// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__1XMNT","app":"Layout_app__cwCDY","right":"Layout_right__KGc9B","center":"Layout_center__LOQbx"};